import { CellContainer } from "./components/CellContainer";
export default CellContainer;